import { gql } from '@apollo/client'

export const NEXT_RECURRING_APPOINTMENT_SLOT = gql`
  query nextRecurringAppointmentSlot {
    nextRecurringAppointmentSlot {
      coachName
      meetingAt
      appointmentKind
    }
  }
`
